<ng-container *ngFor="let modelFolder of modelFolders">
  <div *ngIf="getFilesToBeDisplayed(modelFolder.files).length > 0" class="folder-container">
    <div class="folder-header">
      <div class="folder-name">
        <mat-icon style="font-size:18px; width:18px; height:18px; color: rgba(63,81,181,0.7);">folder_open</mat-icon>
        {{modelFolder.pathFromRoot}}
        <span class="folder-file-count">{{getFilesToBeDisplayed(modelFolder.files).length}}</span>
      </div>
      <div>
        <button mat-stroked-button color="primary" (click)="addFilesToFolder(modelFolder)" [disabled]="isReadOnly">
          <mat-icon>note_add</mat-icon>
          <span>Add file(s)</span>
        </button>
      </div>
    </div>
    <table mat-table [dataSource]="getFilesToBeDisplayed(modelFolder.files)" class="mat-elevation-z8"
      aria-labelledby="model folders">

      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('select')" [style.min-width]="getColumnWidth('select')">
          <mat-checkbox (change)="$event ? masterToggle(modelFolder) : null"
            [checked]="folderSelection.get(modelFolder.pathFromRoot).hasValue() && isAllSelected(modelFolder)"
            [indeterminate]="folderSelection.get(modelFolder.pathFromRoot).hasValue() && !isAllSelected(modelFolder)"
            [aria-label]="checkboxLabel(modelFolder)">
          </mat-checkbox>
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'select')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile">
          <mat-checkbox *ngIf="modelFolderFile?.fileInfo?.updateInfo?.mode !== 'not-allowed'"
            (click)="$event.stopPropagation()" (change)="$event ? onSelect(modelFolder, modelFolderFile) : null"
            [checked]="folderSelection.get(modelFolder.pathFromRoot).isSelected(modelFolderFile)"
            [disabled]="modelFolderFile?.fileInfo?.updateInfo?.mode === 'add' && modelFolderFile.fileInfo.isPrimaryFile"
            [aria-label]="checkboxLabel(modelFolder, modelFolderFile)">
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="conflict">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('conflict')" [style.min-width]="getColumnWidth('conflict')">
          Conflict
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'conflict')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile">
          <button mat-icon-button aria-label="conflict" color="warn"
            *ngIf="modelFolderFile?.fileInfo?.updateInfo?.conflictsWithChangesInSizeAndDate?.length > 0"
            [matTooltip]="getTooltipForConflicts(modelFolderFile?.fileInfo?.updateInfo?.conflictsWithChangesInSizeAndDate)">
            <mat-icon>new_releases</mat-icon>
          </button>
          <button mat-icon-button aria-label="conflict"
            *ngIf="((modelFolderFile?.fileInfo?.updateInfo?.conflictsWithChangesInSizeAndDate?.length ?? 0) === 0) && modelFolderFile?.fileInfo?.updateInfo?.conflictsWithSameSizeAndDate?.length > 0"
            [matTooltip]="getTooltipForConflictsButMostLikelyNotModified(modelFolderFile?.fileInfo?.updateInfo?.conflictsWithSameSizeAndDate)">
            <mat-icon>report</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="changeType">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('changeType')" [style.min-width]="getColumnWidth('changeType')">
          Type
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'changeType')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile">
          <mat-icon aria-label="add" color="primary" *ngIf="modelFolderFile?.fileInfo?.updateInfo?.mode === 'add'"
            matTooltip="file is being added">
            add
          </mat-icon>
          <mat-icon color="warn" *ngIf="modelFolderFile?.fileInfo?.updateInfo?.mode === 'delete'"
            matTooltip="file is being removed">
            remove
          </mat-icon>
          <mat-icon
            *ngIf="modelFolderFile?.fileInfo?.updateInfo?.mode === 'update' && modelFolderFile?.fileInfo?.updateInfo?.sizeOrDateDifferenceWithUpdatedFile"
            matTooltip="file is being updated">
            upgrade
          </mat-icon>
        </td>
      </ng-container>

      <ng-container matColumnDef="index">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('index')" [style.min-width]="getColumnWidth('index')">
          No.
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'index')"></div>
        </th>
        <td mat-cell *matCellDef="let index = index"> {{index + 1}} </td>
      </ng-container>

      <ng-container matColumnDef="options">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('options')" [style.min-width]="getColumnWidth('options')">
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'options')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile">
          <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="options"
            *ngIf="anyOptionExist(modelFolderFile)">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="modelFolderFile.options.view" (click)="onView(modelFolderFile)">
              <mat-icon>visibility</mat-icon>
              <span>View</span>
            </button>
            <button mat-menu-item *ngIf="modelFolderFile.options.edit" (click)="onEdit(modelFolderFile)"
              [disabled]="isReadOnlyValue">
              <mat-icon>edit</mat-icon>
              <span>Edit</span>
            </button>
            <button mat-menu-item *ngIf="modelFolderFile.options.compare" (click)="onCompare(modelFolderFile)"
              [disabled]="isReadOnlyValue">
              <mat-icon>compare</mat-icon>
              <span>Compare</span>
            </button>
            <button mat-menu-item *ngIf="modelFolderFile.options.delete" (click)="onDelete(modelFolderFile)"
              [disabled]="isReadOnlyValue">
              <mat-icon>delete</mat-icon>
              <span>Delete</span>
            </button>
            <button mat-menu-item *ngIf="modelFolderFile.options.timeline" (click)="onTimeline(modelFolderFile)"
              [disabled]="isReadOnlyValue">
              <mat-icon>history</mat-icon>
              <span>Timeline</span>
            </button>
            <button mat-menu-item *ngIf="modelFolderFile.options.download" (click)="onDownload(modelFolderFile)">
              <mat-icon>download</mat-icon>
              <span>Download</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('name')" [style.min-width]="getColumnWidth('name')">
          Name
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'name')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile">
          {{modelFolderFile.name}}
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('type')" [style.min-width]="getColumnWidth('type')">
          <div class="type-header-container">
            <span class="type-label">Type</span>
            <div class="type-select-all" *ngIf="isInUploadMode(modelFolder)">
              <mat-checkbox 
                (change)="toggleAllAsType(modelFolder, 'input')"
                [checked]="isAllFilesOfType(modelFolder, 'input')"
                [indeterminate]="!isAllFilesOfType(modelFolder, 'input') && areAnyFilesOfType(modelFolder, 'input')"
                [matTooltip]="'Select All as Input'"
                class="type-checkbox">
                <span class="checkbox-label">Input</span>
              </mat-checkbox>
              <mat-checkbox 
                (change)="toggleAllAsType(modelFolder, 'output')"
                [checked]="isAllFilesOfType(modelFolder, 'output')"
                [indeterminate]="!isAllFilesOfType(modelFolder, 'output') && areAnyFilesOfType(modelFolder, 'output')"
                [matTooltip]="'Select All as Output'"
                class="type-checkbox">
                <span class="checkbox-label">Output</span>
              </mat-checkbox>
            </div>
          </div>
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'type')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile">
          <mat-button-toggle-group *ngIf="modelFolderFile?.fileInfo?.updateInfo?.optional" name="fontStyle" [disabled]="!modelFolderFile?.fileInfo?.updateInfo?.optional"
            [value]="modelFolderFile.fileInfo.type"
            (change)="onModelFolderFileTypeChange($event.value, modelFolderFile)"
             aria-label="Font Style">
            <mat-button-toggle value="input">input</mat-button-toggle>
            <mat-button-toggle value="output">output</mat-button-toggle>
          </mat-button-toggle-group>
          <span *ngIf="!modelFolderFile?.fileInfo?.updateInfo?.optional">  {{modelFolderFile.fileInfo.type}} </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="size">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('size')" [style.min-width]="getColumnWidth('size')">
          Size(in kb)
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'size')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile"> {{modelFolderFile.fileInfo.size / 1024 | number:'1.0-2'}} </td>
      </ng-container>

      <ng-container matColumnDef="createdUser">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('createdUser')" [style.min-width]="getColumnWidth('createdUser')">
          Created By
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'createdUser')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile"> {{modelFolderFile.fileInfo.createdUserId}} </td>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef [style.width]="getColumnWidth('createdDate')" [style.min-width]="getColumnWidth('createdDate')">
          Created Date
          <div class="column-resize-handle" (mousedown)="onResizeColumnStart($event, 'createdDate')"></div>
        </th>
        <td mat-cell *matCellDef="let modelFolderFile"> {{modelFolderFile.fileInfo.createdDateTime | date : 'short'}}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="folderDisplayedColumns.get(modelFolder.pathFromRoot)"></tr>
      <tr mat-row *matRowDef="let modelFolderFile; columns: folderDisplayedColumns.get(modelFolder.pathFromRoot);"
        [ngClass]="modelFolderFile.fileInfo.type" [class.removed]="modelFolderFile.options.undoRemove"></tr>
    </table>
  </div>
  <app-view-model-folders [searchText]="searchText" [isReadOnly]="isReadOnlyValue"
    [modelFolders]="modelFolder.subFolders" (addFile)="onAddFileFromChildren($event)"
    (selectionChange)="onSubFolderSelectionChange($event)"
    (showFileTimeline)="onShowFileTimelineFromSubFolder($event)"></app-view-model-folders>
</ng-container>
